module.exports = __webpack_public_path__ + "img/history.55953c04.svg";